import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, finalize, map, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState,
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
    fetchTemplates,
    fetchTemplatesSuccess,
    addRecord,
    addRecordSuccess,
    addRecordFailure
} from './sent-correspondence.action';



import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { SentCorrespondencesTableService } from './sent-correspondence-table.service';
import { fetchSingleRecordSuccess as dossierRecordSuccess } from '../Dossier/dossier.action';
import { RootReducerState } from '..';
import { Store } from '@ngrx/store';
import { RouterService } from 'src/app/core/services/router.service';
import { HelperService } from 'src/app/core/services/helper.service';


@Injectable()
export class SentCorrespondencesRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchRecords),
            exhaustMap((data) => {
                const url = 'correspondence/'+data.id;
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {

                        const data = response.data;
                        const listData = data.records;
                        const total = data.pagination.total;

                        this.moduleTableService.page = data.pagination.current_page;
                        this.moduleTableService.lastPage = data.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page);

                        this.alertService.triggerAlert(response.message, "success");
                        return fetchRecordsSuccess({listData: listData, total: total});

                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchRecordsFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap((data: any) => {
                
                const dossierId = data.dossierId;
                const url = `correspondence/${data.dossierId}/${data.id}/edit`;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {

                        const data = response.data;
                        this.alertService.triggerAlert(response.message, "success");
                        this.store.dispatch(dossierRecordSuccess({singleData: data.dossier, dossierData: {countryList: [], clubs: [], categories: [], seasons: []}}));
                        
                        return fetchSingleRecordSuccess({singleData: data.task});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                                this.routeService.triggerRoute(null, ("/dossiers/detail/"+dossierId));
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchTemplates$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchTemplates),
            exhaustMap((data: any) => {
                
                const type = data.id;
                const url = `correspondence-template/${data.id}`;
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {

                        const data = response.data;
                        this.alertService.triggerAlert(response.message, "success");
                        return fetchTemplatesSuccess({templates: data.templates});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                // this.alertService.triggerAlert(error, "error");
                                // this.routeService.triggerRoute(null, ("/dossiers/detail/"+dossierId));
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    addData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addRecord),
            exhaustMap((data: any) => {
                const url = `correspondence/${data.dossierId}`;
                return this.crudServerService.addData(url, data.newData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        this.routeService.triggerRoute(response, `/dossiers/detail/${data.dossierId}`, { activeTab: 'correspondence' });
                        return addRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => addRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private moduleTableService: SentCorrespondencesTableService,
        private tableService: DatatableService,
        private store: Store<RootReducerState>,
        private routeService: RouterService,
        public helperService: HelperService
    ) { }

}